import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código'},
    {title: 'Dirección'},
];


class AddressesPartnerModal extends Component {
    componentDidMount() {
        this.closeAction();
    }

    closeAddress = async () => {
        $('#addressPartnerModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#addressPartnerModal').on('hidden.bs.modal', function () {
            //console.log("cerrar AddressesPartnerModal");
            cleanData();
        });
    };

    render() {
        const {data, selectAddresses,deleteAddresses} = this.props;
        //console.log("data AddressesPartnerModal", data);

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="addressPartnerModal"></div>;
        }

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog" id="addressPartnerModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Lista de Direcciónes</h4>
                                <button type="button" className="close" onClick={this.closeAddress} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"addressesModal"} action={selectAddresses} deleteAddresses={deleteAddresses}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeAddress}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressesPartnerModal;